import { SxProps, Theme } from "@mui/material";
import colors from "../../theme/Colours";

export const dialogPaperStyle: SxProps<Theme> = {
  borderRadius: "4px",
  maxWidth: "360px",
  width: "100%",
  margin: "32px",
};

export const dialogTitleStyle: SxProps<Theme> = {
  display: "flex",
  justifyContent: "space-between",
  fontSize: "14px",
  padding: "12px 24px",
};

export const dialogContentStyle: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  paddingBottom: "25px !important",
  paddingX: "24px",
};

export const textFieldStyle: SxProps<Theme> = {
  width: "300px",
  height: "43px",
  borderRadius: "4px",
  "& .MuiOutlinedInput-root": {
    height: "43px",
    fontSize: "14px",
    fontWeight: 400,
    fontFamily: "Poppins, Arial, Helvetica, sans-serif, Inter",
    borderRadius: "4px",
  },
  "& .MuiInputBase-input": {
    fontSize: "14px",
  },
};

export const downloadButtonStyle: SxProps<Theme> = {
  backgroundColor: colors.primaryButtonOrange,
  borderRadius: "50px",
  maxWidth: "200px",
  maxHeight: "38px",
  fontSize: "14px",
};

export const dialogActionsStyle: SxProps<Theme> = {
  justifyContent: "center",
  pb: 2,
};
